import {Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, {FunctionComponent, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {Team} from "/src/domain/challenges/ChallengeRegistrationData";
import {ArrowRight, PersonAdd} from "@mui/icons-material";

export type TeamsProps = {
    teams: Team[],
    maxTeamParticipants: number,
    isRegistered: boolean,
    isRegActive: boolean,
};

export const Teams: FunctionComponent<TeamsProps> = ({teams, maxTeamParticipants, isRegistered, isRegActive}) => {
    const {t} = useTranslation();

    const [full, notFull] = useMemo(() => {
        const fullTeams = teams.filter(t => t.participants.length === maxTeamParticipants);
        const notFullTeams = teams.filter(t => t.participants.length < maxTeamParticipants);
        return [fullTeams, notFullTeams];
    }, [teams]);
    const classes = useStyles();

    return (
        <div className={classes.container}>
            {teams.length > 0 && <Typography variant="h6">{t('registeredTeams')}</Typography>}
            <TeamsTable teams={notFull} isFull={false} isRegistered={isRegistered} isRegActive={isRegActive}/>
            <br/>
            <TeamsTable teams={full} isFull={true} isRegistered={isRegistered} isRegActive={isRegActive}/>
        </div>
    );
};

type TeamsTableProps = {
    teams: Team[];
    isFull: boolean;
    isRegistered: boolean;
    isRegActive: boolean;
}

const TeamsTable: FunctionComponent<TeamsTableProps> = ({teams, isFull, isRegistered, isRegActive}) => {
    const {t} = useTranslation();

    const handleClick = (id: number) => {
        window.location.href = `/team?id=${id}`;
    }

    const handleJoinClick = (teamKey: string) => {
        window.location.href = `/team?code=${teamKey}`;
    }

    return (
        <>
            <TableContainer>
                <Table
                    size={'medium'}
                >
                    <TableBody>
                        {teams.map(team => (
                            <TableRow
                                key={team.id}
                            >

                                <TableCell
                                    component="th"
                                    scope="row"
                                    padding="none"
                                >
                                    {team.name + (` (${team.participants.length}) `) + (team.region ? ` - ${team.region}` : '')}
                                </TableCell>
                                <TableCell align="right">
                                    {
                                        (isFull || isRegistered || !isRegActive || team.isPrivate) ?
                                            (<Button variant="contained" color="primary" endIcon={<ArrowRight/>}
                                                     onClick={(_) => handleClick(team.id)}>
                                                {t('goToTeam')}
                                            </Button>)
                                            : ((
                                                <Button variant="outlined" color="primary" startIcon={<PersonAdd/>}
                                                        onClick={(_) => handleJoinClick(team.teamCode)}>
                                                    {t('joinLabel')}
                                                </Button>))
                                    }
                                </TableCell>
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

const useStyles = makeStyles({
    container: {
        margin: "2rem"
    },
});
